import { Head } from '@inertiajs/react';
import { Card, CardContent, CardHeader } from '@/components/ui/card';
import type { AdminSponsorsIndex } from '@/types';
import { CreateSponsorDialog } from './components/CreateSponsorDialog';
import { SponsorsSearch } from './components/SponsorsSearch';
import { SponsorsTable } from './components/SponsorsTable';

export default function Index({
  sponsors,
  eventSlug,
  eventName,
  search,
  title,
}: AdminSponsorsIndex) {
  return (
    <>
      <Head title={title} />
      <div className="container mx-auto space-y-6 py-8">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="font-bold text-3xl tracking-tight">Sponsors</h1>
            <p className="text-muted-foreground">
              Manage sponsors and their credits for {eventName}
            </p>
          </div>
          <CreateSponsorDialog eventSlug={eventSlug} />
        </div>

        <Card>
          <CardHeader>
            <SponsorsSearch eventSlug={eventSlug} search={search} />
            <p className="text-muted-foreground text-sm">
              {sponsors.length} {sponsors.length === 1 ? 'sponsor' : 'sponsors'}{' '}
              found
            </p>
          </CardHeader>
          <CardContent className="p-0">
            <SponsorsTable eventSlug={eventSlug} sponsors={sponsors} />
          </CardContent>
        </Card>
      </div>
    </>
  );
}
